module.exports = "/assets/data/c11a39e42aa3f39e737861a2d940d9e0-NG24.data.json";